import React from "react";

import { Select } from "../../components/ui";

import "./xero-org-select.scss";

/**
 * "Xero Organisation" picker shown at the top of the PAYMENTS section on the
 * order and sell flows. Selects which connected Xero org the invoice / purchase
 * order / payments are created in. Hidden when no orgs are connected. Locks once
 * a Xero document exists so an order/request can't be split across orgs.
 *
 * Rendered inside the shared `.order-payments` container in both flows so it
 * lines up with the DEPOSIT PAID fields; its width matches the currency + amount
 * fields below it.
 */
export function XeroOrgSelect({ organisations, value, onChange }) {
  if (!organisations?.length) {
    return null;
  }

  return (
    <div className="xero-org-select mb-4">
      <div className="strong-label mb-2">Xero Organisation:</div>
      {/* No value until picked — the sell flow gates purchase-order
          generation on a chosen org. Ids may arrive as strings; match loosely. */}
      <Select
        fullWidth
        label="Xero Organisation"
        placeholder="Select organisation"
        options={organisations.map((o) => ({ value: Number(o.id), label: o.org_label }))}
        value={value == null || value === "" ? null : Number(value)}
        onChange={(v) => onChange(v ?? null)}
      />
    </div>
  );
}
